module.exports = __webpack_public_path__ + "static/ecokoalatoy-ee8c724f9baf11302ebccca88f1642f6.jpeg";